import { Routes, Route } from 'react-router-dom';
import Login from './Pages/Login';
import Tables from './Pages/Tables';
import Counter from './Pages/Counter';
import Home from './Pages/Home';
import SignUp from './Pages/SignUp';
import ForgetPassword from './Pages/ForgetPassword';
import Dashboard from './Pages/DashBord';
import AppView from './Pages/App-View';
import VoiceSearch from './component/VoiceSearch';

function Router() {
  return (
    <Routes>
      <Route path='/' element={<AppView />} />
      <Route path='/search' element={<VoiceSearch />} />
      <Route path='/counter' element={<Counter />} />
      <Route path='/auth' element={<Login />} />
      <Route path='/signup' element={<SignUp />} />
      <Route path='/dashboard' element={<Dashboard />} />
      <Route path='/forget-password' element={<ForgetPassword />} />
      <Route path='/home' element={<Home />} />
      <Route path='/table' element={<Tables />} />
    </Routes>
  );
}

export default Router;
